export const SettingsSection = {
  Container: ({ children }: { children: React.ReactNode }) => (
    <div className="flex w-full flex-row flex-wrap gap-y-4 border-b border-gray-300 py-4">
      {children}
    </div>
  ),
  TitleContainer: ({
    title,
    subTitle,
  }: {
    title: React.ReactNode;
    subTitle: React.ReactNode;
  }) => (
    <div className="flex w-full flex-col lg:w-2/5">
      <div className="text-base font-semibold">{title}</div>
      <div className="text-sm text-gray-400">{subTitle}</div>
    </div>
  ),
  Content: ({ children }: { children: React.ReactNode }) => (
    <div className="bg-gray-0 flex w-full rounded-xl border border-gray-200 shadow-sm lg:w-3/5">
      {children}
    </div>
  ),
};
